import React from 'react';
import ReactDOM from 'react-dom';
import ReactTable from 'reactable';
import { Website } from './website.js';

const menuBreakPoint = 991;

var Table = Reactable.Table,
    Thead = Reactable.Thead,
    Th = Reactable.Th,
    Tr = Reactable.Tr,
    Td = Reactable.Td;

export class DealerTable extends React.Component {
    constructor(props){
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props.activeRegion !== nextProps.activeRegion || this.props.loadingDealers !== nextProps.loadingDealers){
            return true;
        }
        return false;
    }

    render() {
        if(this.props.loadingDealers){
            return <p>{this.props.translations.loading}</p>;
        }
        else if(this.props.activeRegion.Dealers === undefined || this.props.activeRegion.IsInternational){
            return <p></p>;
        }

        //special column for Russia
        let streetColHeader = this.props.translations.headerStreet;
        let tableRenderer = this.renderTable.bind(this);
        if (this.props.activeRegion.RegionIsoCode === "RU") {
            streetColHeader = this.props.translations.headerArea;
            tableRenderer = this.renderTableRU.bind(this);
        }
        
        //Set itemsPerPage to 0 to disable pagination if dealers is less than 15
        let itemsPerPage = this.props.activeRegion.Dealers.length > 15 ? 15 : 0;

        //Different order of columns for table in mobile
        if (window.innerWidth <= menuBreakPoint) {
            tableRenderer = this.renderTableMobile.bind(this);
            return (
                
                <div>
                    <h3>
                        <a data-toggle="collapse" data-target="#table-wrapper" className="collapsed show-table">
                            <span className="expand-text">{this.props.translations.expandTable}</span>
                            <span className="expand-icon"></span>                          
                        </a>
                    </h3>
                    <div id="table-wrapper" className="collapse table-responsive">
                        <Table className="table dealer-table"
                            id="table"
                            sortable={["name", "city"]}
                            defaultSort={{ column: "name" }}
                            noDataText={this.props.translations.noDealersFound}
                            filterPlaceholder={this.props.translations.searchPlaceholder}
                            itemsPerPage={itemsPerPage}
                            previousPageLabel='<' nextPageLabel='>'  >
                            <Thead>
                                <Th column="name">
                                    {this.props.translations.headerDealer}
                                    <div className="sort-wrapper">
                                        <div className="sort-arrow-up sort-arrow"></div>
                                        <div className="sort-arrow-down sort-arrow"></div>
                                    </div>
                                </Th>
                                <Th column="phone" className="center">
                                    {this.props.translations.headerPhone}
                                </Th>
                                <Th column="city">
                                    {this.props.translations.headerCity}
                                    <div className="sort-wrapper">
                                        <div className="sort-arrow-up sort-arrow"></div>
                                        <div className="sort-arrow-down sort-arrow"></div>
                                    </div>
                                </Th>
                            </Thead>
                            {this.props.activeRegion.Dealers.map((dealer) => {
                                return tableRenderer(dealer);
                            })}
                        </Table>
                    </div>
                </div>);
        }

        return (
            <div>    
                <h3 className="accordion">
                    <a data-toggle="collapse" data-target="#table-wrapper" className="collapsed show-table">
                        <span className="expand-text">{this.props.translations.expandTable}</span>
                        <span className="expand-icon"></span>                        
                    </a>
                </h3>
                <div id="table-wrapper" className="collapse table-responsive">
                    <Table className="table dealer-table"
                            id="table"
                            sortable={["name", "street", "zipcode", "city"]}
                            defaultSort={{column:"name"}}
                            noDataText={this.props.translations.noDealersFound}
                            filterPlaceholder={this.props.translations.searchPlaceholder}
                            itemsPerPage={itemsPerPage}
                            previousPageLabel='<' nextPageLabel='>'  >
                         <Thead>
                            <Th column="name">
                                {this.props.translations.headerDealer}
                                <div className="sort-wrapper">
                                    <div className="sort-arrow-up sort-arrow"></div>
                                    <div className="sort-arrow-down sort-arrow"></div>
                                </div>
                            </Th>
                            <Th column="street" className="hide-mobile">
                                {streetColHeader}
                                <div className="sort-wrapper">
                                    <div className="sort-arrow-up sort-arrow"></div>
                                    <div className="sort-arrow-down sort-arrow"></div>
                                </div>
                            </Th>
                            <Th column="zipcode" className="hide-mobile">
                                {this.props.translations.headerZipCode}
                                <div className="sort-wrapper">
                                    <div className="sort-arrow-up sort-arrow"></div>
                                    <div className="sort-arrow-down sort-arrow"></div>
                                </div>
                            </Th>
                            <Th column="city">
                                {this.props.translations.headerCity}
                                <div className="sort-wrapper">
                                    <div className="sort-arrow-up sort-arrow"></div>
                                    <div className="sort-arrow-down sort-arrow"></div>
                                </div>
                            </Th>
                            <Th column="phone" className="center">
                                {this.props.translations.headerPhone}
                            </Th>
                            <Th column="website" className="hide-mobile center">
                                {this.props.translations.headerWebsite}
                            </Th>
                         </Thead>
                            {this.props.activeRegion.Dealers.map((dealer) => {
                                return tableRenderer(dealer);
                            })}
                    </Table>
                </div>
            </div>);
    }

    renderTableRU(dealer) {
        var row =
        <Tr key={dealer.Id} id={dealer.Id} onClick={(event) => this.props.onDealerClick(dealer, event)}>
            <Td column="name">
                {dealer.Name}
            </Td>
            <Td column="street" className="hide-mobile">
                {dealer.Area}
            </Td>
            <Td column="zipcode" className="hide-mobile">
                {dealer.ZipCode}
            </Td>
            <Td column="city">
                {dealer.City}
            </Td>
            <Td column="phone" className="center" value={dealer.Phone}>
                <span className="icon-phone" />
            </Td>
            <Td column="website" className="hide-mobile center" value={dealer.Web}>
                <Website webaddress={dealer.Web} target="_blank" icon={true} />
            </Td>
        </Tr>;
        return row;
    }

    renderTableMobile(dealer) {
        var row =
        <Tr key={dealer.Id} id={dealer.Id} onClick={(event) => this.props.onDealerClick(dealer, event)}>
            <Td column="name">
                {dealer.Name}
            </Td>
            <Td column="phone" className="center" value={dealer.Phone}>
                <span className="icon-phone" />
            </Td>
            <Td column="city">
                {dealer.City}
            </Td>
        </Tr>;
        return row;
    }

    renderTable(dealer){ var row =
        <Tr key={dealer.Id} id={dealer.Id} onClick={(event) => this.props.onDealerClick(dealer, event)}>
            <Td column="name">
                {dealer.Name}
            </Td>
            <Td column="street" className="hide-mobile">
                {dealer.Street}
            </Td>            
            <Td column="zipcode" className="hide-mobile">
                {dealer.ZipCode}
            </Td>
            <Td column="city">
                {dealer.City}
            </Td>            
            <Td column="phone" className="center" value={dealer.Phone}>
                <span className="icon-phone" />
            </Td>
            <Td column="website" className="hide-mobile center" value={dealer.Web}>
                <Website webaddress={dealer.Web} target="_blank" icon={true} />
            </Td>
        </Tr>;
        return row;
    }
}
